import { RouteConfig } from 'vue-router';

export const donationsChildren: Array<RouteConfig> = [
  {
    path: 'overview',
    name: 'donations-overview',
    component: (): Promise<typeof import('vue')> =>
      import(/* webpackChunkName: "main" */ '../views/donations/Donations.vue')
  },
  {
    path: ':campaignId',
    name: 'single-campaign',
    component: (): Promise<typeof import('vue')> =>
      import(/* webpackChunkName: "main" */ '../components/campaigns/campaign-donations/CampaignDonations.vue')
  },
  {
    path: '',
    redirect: {
      name: 'donations-overview'
    }
  }
];
